module.exports = __webpack_public_path__ + "img/Ranking.2ec3370b.jpg";